import { receiptStateLabels, type ReceiptState } from '../../domain/goods-intake';

const tones: Record<ReceiptState, string> = {
  EXPECTED: 'state-badge',
  RECEIVING: 'state-badge state-badge-active',
  POSTED: 'state-badge state-badge-ready',
  CANCELLED: 'state-badge state-badge-muted',
};

export function ReceiptStateBadge({ state }: { state: ReceiptState }) {
  return <span className={tones[state]}>{receiptStateLabels[state]}</span>;
}
